<template>
  <div>
  <div class="w-full  header" >
    <div class="top">
      <div class="topcontent">
        <div>欢迎莅临广东元正招标采购有限公司</div>
        <div><span>设为首页</span> | <span>加入收藏</span><span> | <span  @click="returnIndex">返回首页</span></span></div>
      </div>
    </div>
    <div class="w-inner" style="float:right;">
      <div class="warnmsg" style="font-size:13px;">
        <version-reminder></version-reminder>
      </div>
    </div>
    <div flex="cross:center" class="base-bai">
    <div class="w-inner" style="display:flex;justify-content:space-between;align-items:center;">
      <div @click="toIndex">
        <div v-if="headlogo" style="float: left;width:380px;"><img :src="headlogo" style="width:100%;height:100%;cursor: pointer;"/></div>
        <!--<div v-else><img width="334" height="60" src="../../assets/images/logo2.png"/></div>-->
      </div>
      <div style="display:flex;color:#1d1d1d;font-size: 16px;">
        <div v-for="(item,index) in operMtIdList" @click="change(index,item)" class="selected"
        style="margin-left:10px;cursor: pointer;"
             :class="{active: +firstActiveTab === +item.opermtid}">
          {{item.opermtname}}
        </div>
      </div>
    </div>
    </div>
  </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import versionReminder from '../common/versionReminder'
  export default {
    data () {
      return {
        links: ['/', '/product'],
        operMtIdList: [],
        ww: window
      }
    },
    created () {
      this.$store.dispatch('getSysparam')
      if (!this.firstActiveTab) {
        this.$store.commit('setFirstActiveTab', window.localStorage.getItem('firstActiveTab'))
      }
      this.getOperMtId()
    },
    methods: {
      returnIndex () {
        this.$store.commit('changId', '')
        this.$store.commit('setFirstActiveTab', 0)
        window.localStorage.setItem('firstActiveTab', 0)
        this.$router.push({name: 'home'})
      },
      getOperMtId () {
        this.$store.dispatch('findOperMtId').then(list => {
          list.unshift({opermtname: '首页', opermtid: '0', children: []})
          this.operMtIdList = list
        })
      },
      toIndex () {
        this.$router.push({name: 'home'})
        this.$store.commit('setFirstActiveTab', '0')
      },
      change (index, item) {
        document.documentElement.scrollTop = 0
        this.$store.commit('changId', '')
        this.$store.commit('setFirstActiveTab', item.opermtid)
        window.localStorage.setItem('firstActiveTab', item.opermtid)
        if (index === 0) {
          this.$router.push({name: 'home'})
        } else {
          if (item.opermtlinkaddr === 'zbxx') {
            this.$router.push({name: 'zbxx', query: {type: 1, mtid: item.opermtid}})
          } else if (item.opermtlinkaddr) {
            this.ww.open(item.opermtlinkaddr, '_blank')
          } else {
            this.$router.push({name: 'product', params: {operMtId: item.opermtid}})
          }
        }
      }
    },
    components: { versionReminder },
    computed: {
      ...mapState({
        firstActiveTab: state => state.firstActiveTab,
        sysparam: state => state.sysparam,
        picAddr: state => state.picAddr
      }),
      headlogo () {
        if (this.sysparam.headlogo && this.sysparam.headlogo.sysparambeg) {
          let index = this.sysparam.headlogo.sysparambeg.indexOf('upload/')
          if (index > -1) {
            return this.sysparam.headlogo ? this.picAddr + this.sysparam.headlogo.sysparambeg : ''
          }
        }
      }
    }
  }
</script>
<style scoped>
  .tab-item {
    padding-left: 20px;
  }

  .active {
    color: #0061ca !important;
    /*background: #0061ca !important;*/
  }

  .header {
    top: 0;
    left: 0;
    width: 100%;
    margin: auto;
    background: #FFFFFF;
    height: 117px;
    /* position: fixed; */
    z-index: 99999;
  }
</style>
<style lang="stylus" scoped>
  .top {
    display: flex;
    justify-content: center;
    background-color: #282A35;
    .topcontent {
      width: 1221px;
      line-height: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: #c2c2c2;
      span {
        cursor: pointer;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// WebHeader.vue?5c17775c